import Container from "../ui/Container";
import SectionHeader from "../ui/SectionHeader";

function AboutSection() {
  return (
    <section id="about" className="py-16 sm:py-20">
      <Container className="grid gap-8 lg:grid-cols-[0.72fr_1fr]">
        <SectionHeader title="About Technie" subtitle="The studio exists to turn focused, practical problems into reliable digital products." />
        <div className="max-w-2xl text-sm leading-7 text-secondary sm:text-base">
          <p>
            Technie exists to build practical technology products that solve real-world problems.
            Starting with student-focused tools, the vision is to create an ecosystem of products used by
            thousands of people every day.
          </p>
          <p className="mt-5">
            The work starts narrow, earns trust through usefulness, and expands only when the product has a
            clear reason to exist.
          </p>
        </div>
      </Container>
    </section>
  );
}

export default AboutSection;
